import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyPlanPageRedirectRoute: InvariantJiraRoute = {
	name: 'software-advanced-roadmaps-redirect',
	path: '/secure/PortfolioPlanView.jspa',
};
